var map = {
	"./assets/clickable/yelp.svg": "31a761f0d66017cb0b09",
	"./assets/disabled/yelp.svg": "ff9cf85495b171aae051",
	"./assets/original/yelp.svg": "150be14939654b2a7a06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "845fe381b6897b6e2f41";